import {
	GET_USER_LIST,
	FAIL_GET_USER_LIST,
	SUCCESS_GET_USER_LIST,
	RESET_PROCESS_ERROR,
	GET_JIGYOSHA_LIST,
	FAIL_GET_JIGYOSHA_LIST,
	SUCCESS_GET_JIGYOSHA_LIST,
	LOGIN,
	SET_USER_LIST,
	FAIL_SET_USER_LIST,
	SUCCESS_SET_USER_LIST,
	RESET_MASTER_USERS,
	FETCH_CSV_MASTER_USER,
	FAIL_FETCH_CSV_MASTER_USER,
	SET_CSV_MASTER_USER, GET_USER_QR_PDF, FAIL_GET_USER_QR_PDF, SUCCESS_GET_USER_QR_PDF, CLEAR_GET_USER_QR_PDF,
} from '../../actions';
import {downloadCsvData} from '../../common/utils/download-csv';
import moment from 'moment';


const initialState = {
	data:[],
	jigyoshaData:[],
	JigyoushaCD : null,
	isFetching: false,
	error: undefined,
	isProcessError : false,
	pdfPath : undefined,
	user: {
		UserSeqNO : undefined,
		JigyoushaCD : undefined,
		JigyoushaName : undefined,
		KeiyakuKigyouCD : undefined,
		KeiyakuKigyouName : undefined,
		UserID : undefined,
		UserPassword : undefined,
		UserName : undefined,
		Furigana : undefined,
		Kengen : undefined,
		KengenName : undefined,
		IsSystemAdmin : undefined,
		IsJigyoushaAdmin : undefined,
	},
};
export default function masterUsersSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case LOGIN:
			ret.user =  {
				UserSeqNO : action.payload.UserSeqNO,
				JigyoushaCD : action.payload.JigyoushaCD,
				JigyoushaName : action.payload.JigyoushaName,
				KeiyakuKigyouCD : action.payload.KeiyakuKigyouCD,
				KeiyakuKigyouName : action.payload.KeiyakuKigyouName,
				UserID : action.payload.UserID,
				UserPassword : action.payload.UserPassword,
				UserName : action.payload.UserName,
				Furigana : action.payload.Furigana,
				Kengen : action.payload.Kengen,
				KengenName : action.payload.KengenName,
				IsSystemAdmin : (action.payload.IsSystemAdmin === "1"),
				IsJigyoushaAdmin : (action.payload.IsJigyoushaAdmin === "1"),
			};
			return ret;
		case GET_USER_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_USER_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_USER_LIST:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case GET_JIGYOSHA_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_JIGYOSHA_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_JIGYOSHA_LIST:
			ret.jigyoshaData = action.payload.data;
			ret.isFetching = false;
			if(ret.user.IsJigyoushaAdmin){
				ret.JigyoushaCD = {
					value:ret.user.JigyoushaCD,
					label:ret.user.JigyoushaCD + ' : ' + ret.user.JigyoushaName,
					name : ret.user.JigyoushaName
				};
			}
			return ret;
		case SET_USER_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_SET_USER_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_SET_USER_LIST:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case FETCH_CSV_MASTER_USER:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_CSV_MASTER_USER:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_CSV_MASTER_USER:
			const csvData = action.payload.data;
			const columns = action.payload.columns;
			const now = moment().format('YYYYMMDDhhmmss');
			downloadCsvData("ユーザーマスタ"+now, columns,csvData);
			ret.isFetching = false;
			return ret;
		case GET_USER_QR_PDF:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_USER_QR_PDF:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_USER_QR_PDF:
			ret.pdfPath = action.payload.pdfPath;
			ret.isFetching = false;
			return ret;
		case CLEAR_GET_USER_QR_PDF:
			ret.pdfPath = undefined;
			return ret;
		case RESET_MASTER_USERS:
			ret.data=[];
			ret.jigyoshaData=[];
			ret.JigyoushaCD=null;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/master/users.js